var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"text-h4 no-margin"},[_vm._v("Price Levels")]),_c('add-price-plan-btn',{staticClass:"q-my-md",on:{"added":_vm.add}}),_c('price-plans-table',{ref:"pricePlansTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }